import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom Coaching & Mentorship Software Solutions | RojrzTech',
    description: 'Empower your coaching business with custom membership portals, booking calendars, online course hosting, and client CRM platforms built by RojrzTech.',
  },
  hero: {
    badge: 'COACHING & MENTORSHIP',
    slides: [
      {
        heading: { pre: 'Scale Your', gold: 'Coaching & Mentorship', post: 'Business' },
        subheading: 'We build premium coaching membership portals, automated appointment calendars, video lesson hosting, and client relationship CRMs.',
        pills: ['Course Hosting', 'Booking Calendar', 'Client CRM', 'Video Vault', 'Subscribers Hub'],
        image: '/Coaching1.jpeg',
      },
      {
        heading: { pre: 'Interactive Booking &', gold: 'Calendar Scheduling' },
        subheading: 'Let clients book discovery calls, group workshops, or premium 1-on-1 coaching sessions directly. Sync seamlessly with Google Calendar and Zoom.',
        pills: ['Zoom API Sync', 'Calendar Booking', 'Discovery Calls', 'Email Reminders', 'Stripe POS'],
        image: '/Coaching.jpeg',
      },
      {
        heading: { pre: 'Secure Course Hosting &', gold: 'Membership Vaults' },
        subheading: 'Protect your educational material. Host video modules, downloadable worksheets, and custom resources in a secure subscriber dashboard.',
        pills: ['Video Hosting', 'PDF Downloads', 'Member Logins', 'Auto Paywalls', 'Subscribers Info'],
        image: '/Coaching.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'COACH PORTAL',
    phoneSubtitle: 'Access course vaults and schedule 1-on-1 coaching sessions.',
    tags: [
      { title: 'Zoom & Calendar Sync', desc: 'Sync discovery call schedules and auto-generate unique Zoom invitation links.' },
      { title: 'Local Search Lead Capture', desc: 'Rank top-3 locally for queries like "business coach" or "executive coach".' },
      { title: 'Course Hosting Vault', desc: 'Securely host video modules, lecture slides, and client homework sheets.' },
      { title: 'Interactive Schedulers', desc: 'Allow clients to pick dates, input details, and book consultation slots.' },
      { title: 'Automated Invoice Portal', desc: 'Process client payments, retainer subscriptions, and workshop passes.' },
      { title: 'Client Progress CRM', desc: 'Record private session notes, homework submissions, and track goals.' },
    ],
  },
  videoSection: {
    title: 'Mentorship Dashboard Demo',
    subtitle: 'See how our coaching platform hosts training modules and tracks member feedback in real-time.',
    frameLabel: 'COACH CLIENT MANAGEMENT SYSTEM',
  },
  cards: {
    title: 'Custom Engineering for Coaches & Consultants',
    subtitle: 'We build responsive, membership-driven platforms that protect your digital content and automate client scheduling.',
    items: [
      {
        icon: '🤝',
        title: 'Course & Video Vaults',
        description: 'Provide clients with a modern portal where they can stream lessons, download templates, and submit homework.',
      },
      {
        icon: '⭐',
        title: 'Automated Calendars',
        description: 'Allow clients to book individual or group sessions, synced with your calendar and automated Zoom links.',
      },
      {
        icon: '📊',
        title: 'Client Tracking CRM',
        description: 'Store client profiles, log session notes, upload progress reports, and keep communication organized.',
      },
    ],
  },
  features: {
    title: 'High-Performance Coaching App Features',
    subtitle: 'Everything you need to automate client booking, host courses, and scale your mentorship brand.',
    items: [
      'Interactive Course Player',
      'Google/Zoom API Sync',
      'Automated Retainer Billing',
      'Resource Download Center',
      'In-App Client Messaging',
      'Session Review Forms',
      'Client Goal Trackers',
      'Discovery Call Funnels',
      'Group Workshop Booking',
      'Client Performance Logs',
      'Stripe Payment Gateway',
      'Custom Assessment Tests',
    ],
  },
};

const Coaching = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Coaching;
